const access = [
    {
        id: "cm1",
        description: "Visualizar Dashboard"
    },
    {
        id: "cm1u",
        description: "Visualizar e realizar tranferência"
    },
    {
        id: "cm1r1",
        description: "Visualizar e realizar antecipação"
    },
    {
        id: "cm1r2",
        description: "Visualizar detalhes de uma transação"
    },
    {
        id: "cm1e",
        description: "Realizar exportação das transações"
    },
    {
        id: "cm2",
        description: "Visualizar Menu Cliente"
    },
    {
        id: "cm2c",
        description: "Adicionar cliente"
    },
    {
        id: "cm2e",
        description: "Exportar cliente"
    },
    {
        id: "cm2r",
        description: "Visualizar dados completos do cliente"
    },
    {
        id: "cm2u",
        description: "Atualizar cliente"
    },
    {
        id: "cm2d",
        description: "Remover cliente"
    },
    {
        id: "cm3",
        description: "Visualizar Menu Cartão"
    },
    {
        id: "cm3a1",
        description: "Tokenizar cartão"
    },
    {
        id: "cm3a2",
        description: "Efetuar venda com cartão não-presente"
    },
    {
        id: "cm3a3",
        description: "Gerar link de pagamento (Cartão)"
    },
    {
        id: "cm4",
        description: "Visualizar Menu Boleto"
    },
    {
        id: "cm4a1",
        description: "Gerar boleto expresso"
    },
    {
        id: "cm4a2",
        description: "Gerar boleto completo"
    },
    {
        id: "cm4a3",
        description: "Visualizar boletos já gerados"
    },
    {
        id: "cm5",
        description: "Visualizar Menu Assinaturas"
    },
    {
        id: "cm5a1",
        description: "Visualizar Assinaturas"
    },
    {
        id: "cm5a1c",
        description: "Adicionar assinaturas"
    },
    {
        id: "cm5a1e",
        description: "Exportar assinaturas"
    },
    // {
    //     id: "cm5a1r",
    //     description: "Visualizar dados assinaturas"
    // },
    {
        id: "cm5a1d",
        description: "Inativar/Reativar assinaturas"
    },
    {
        id: "cm5a2",
        description: "Visualizar Planos de recorrência"
    },
    {
        id: "cm5a2c",
        description: "Adicionar plano de recorrência"
    },
    {
        id: "cm5a2e",
        description: "Exportar planos de recorrência"
    },
    {
        id: "cm5a2r",
        description: "Visualizar detalhes do plano de recorrência"
    },
    {
        id: "cm5a2u",
        description: "Atualizar planos de recorrência"
    },
    {
        id: "cm5a2d",
        description: "Remover plano de recorrência"
    },
    {
        id: "cm5a3",
        description: "Gerar link de pagamento (Assinaturas)"
    },
    {
        id: "cm6",
        description: "Visualizar menu de Configuração"
    },
    {
        id: "cm6a1",
        description: "Visualizar dados cadastrais"
    },
    {
        id: "cm6a1u",
        description: "Alterar dados cadastrais"
    },
    {
        id: "cm6a2",
        description: "Visualizar meios de pagamento"
    },
    {
        id: "cm6a2c",
        description: "Adicionar meio de pagamento"
    },
    {
        id: "cm6a2u",
        description: "Alterar meio de pagamento"
    },
    {
        id: "cm6a3",
        description: "Visualizar troca de senhas"
    },
    {
        id: "cm6a3u1",
        description: "Alterar senha de login"
    },
    {
        id: "cm6a3u2",
        description: "Alterar senha de transferência"
    },
    {
        id: "cm6a4",
        description: "Visualizar Planos/Taxas"
    },
    {
        id: "cm6a5",
        description: "Visualizar configurações gerais"
    },
    {
        id: "cm6a5u1",
        description: "Alterar forma de feedback"
    },
    {
        id: "cm6a5u2",
        description: "Alterar pré-definições do boleto completo"
    },
    {
        id: "cm8",
        description: "Visualizar menu de Campanhas"
    },
    {
        id: "cm8a1",
        description: "Gerenciar campanhas"
    },
    {
        id: "cm8a2",
        description: "Visualizar doações"
    },
];

export default access;